var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:`kpb-section kpb-section--theme-${_vm.theme} kpb-section--width-${_vm.width}`},[_c('ScrollAnchor',{attrs:{"data":_vm.scrollId}}),_c('div',{staticClass:"kpb-section__container"},[(_vm.title)?_c('h2',{staticClass:"kpb-section__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }